// @flow
import React, { Component, Fragment } from 'react';
import { ProfileActions } from 'store/actionCreators';
import { type ContextRouter, withRouter } from 'react-router-dom';
import UserSeriesList from 'components/user/UserSeriesList/UserSeriesList';
import { type State } from 'store';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { type SeriesItemData } from 'store/modules/profile';

type Props = {
  seriesList: ?(SeriesItemData[]),
  shouldCancel: boolean,
} & ContextRouter;

class UserSeriesContainer extends Component<Props> {
  initialize = async () => {
    if (this.props.shouldCancel) return;
    const { username } = this.props.match.params;
    try {
      if (!username) return;
      await ProfileActions.getSeriesList(username);
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    ProfileActions.setSideVisibility(false);
    this.initialize();
  }

  componentWillUnmount() {
    ProfileActions.setSideVisibility(true);
  }

  render() {
    const { profile, seriesList, displayName, username } = this.props;
    if (!seriesList) return null;
    return (
      <Fragment>
        {profile && (
          <Helmet>
            <title>{`${displayName}의 시리즈 | 캐시바이`}</title>
            <meta
              name="description"
              content={`${displayName}님이 캐시바이에서 관심 있어 한 시리즈를 확인하세요.`}
            />
          </Helmet>
        )}
        <UserSeriesList seriesList={seriesList} />
      </Fragment>
    );
  }
}

export default connect((state: State) => ({
  seriesList: state.profile.seriesList,
  shouldCancel: state.common.ssr && !state.common.router.altered,
  profile: state.profile.profile,
  displayName: state.profile.profile && state.profile.profile.display_name,
  username: state.profile.profile && state.profile.profile.username,
}))(withRouter(UserSeriesContainer));



// WEBPACK FOOTER //
// ./src/containers/user/UserSeriesContainer.js